/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $modal = $('#movie-Stage');
	var $content = $('#movie-Iframe'); // preload
	
	(0, _module.preload)(); // // resizing
	// import {resizing} from "../include/module";
	// resizing();
	// //ページ内リンクのアニメーション
	// import {anchorScroll} from "../include/module";
	// anchorScroll();
	// //ページTOP
	// import {backToTop} from "../include/module";
	// backToTop();
	
	$(window).on('load', function () {
	  showMovie();
	  showImg();
	  pageTop();
	  anchorLink();
	  scrollAnime();
	}); // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var showMovie = function showMovie() {
	  // open
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children().remove();
	    }); //
	    // $modal.stop().fadeOut(300, function(){
	    //   $content.children('iframe').remove();
	    // });
	  });
	}; // ------------------------------------------------------------------------
	// showImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var showImg = function showImg() {
	  // open
	  $('.js-Img').on('click', function () {
	    var dataID = $(this).attr('data-img');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //img append
	      $content.append('<img src="' + dataID + '">'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var pageTop = function pageTop() {
	  $("#st-Footer_pagetop").on("click", function () {
	    var linkSpeed = 700;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 0;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  } //ページ内リンク
	
	
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 700;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// scrollAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var scrollAnime = function scrollAnime() {
	  var controller = new ScrollMagic.Controller();
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .9
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.backToTop = exports.anchorScroll = exports.resizing = exports.preload = void 0;
	var $window = $(window);
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height(); //const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href; // preload
	
	var preload = function preload() {
	  var timer = 0;
	  $(window).on('load', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	
	    timer = setTimeout(function () {
	      $("body").removeClass("preload");
	    }, 100);
	  });
	}; // resizing
	
	
	exports.preload = preload;
	
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    $("body").addClass("resizing");
	
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	
	    timer = setTimeout(function () {
	      $("body").removeClass("resizing");
	    }, 100);
	  });
	}; //ページ内リンクのアニメーション
	
	
	exports.resizing = resizing;
	
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	}; //ページTOP
	
	
	exports.anchorScroll = anchorScroll;
	
	var backToTop = function backToTop() {
	  var topBtn = $('.st-Footer_BackToTop');
	  topBtn.css({
	    visibility: 'hidden',
	    opacity: 0
	  });
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.css({
	        visibility: 'visible',
	        opacity: 1
	      });
	    } else {
	      topBtn.css({
	        visibility: 'hidden',
	        opacity: 0
	      });
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	}; //export
	

	exports.backToTop = backToTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js